// ============================================================================
// 📦 VERSION: 2025.12.12.1000
// ============================================================================
// TRAK Quiz Game - Auth Component (Login/Register)
// ============================================================================
import React, { useState } from 'react';
import { login, register, isLoggedIn, logout } from '../api';
import PhoneInput from './PhoneInput';  // ← ADD THIS IMPORT

const AuthScreen = ({ onAuthSuccess, playerData, initialMode = 'login' }) => {
  const [mode, setMode] = useState(initialMode); // 'login' or 'register'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phoneData, setPhoneData] = useState(null);  // ← ADD THIS STATE
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Update mode when initialMode prop changes
  React.useEffect(() => {
    setMode(initialMode);
  }, [initialMode]);

  // If already logged in, show profile
  if (isLoggedIn() && playerData) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
        <div className="bg-gray-800 rounded-2xl p-6 w-full max-w-sm">
          <div className="text-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
              <span className="text-3xl">👤</span>
            </div>
            <h2 className="text-white text-xl font-bold">{playerData.name}</h2>
            <p className="text-gray-400 text-sm">{playerData.email}</p>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-gray-700 rounded-lg p-3 text-center">
              <p className="text-yellow-400 text-2xl font-bold">{(playerData.stats?.totalTraks || playerData.total_traks || 0).toLocaleString()}</p>
              <p className="text-gray-400 text-xs">TRAKs</p>
            </div>
            <div className="bg-gray-700 rounded-lg p-3 text-center">
              <p className="text-orange-400 text-2xl font-bold">{playerData.stats?.currentStreak || playerData.current_streak || 0}</p>
              <p className="text-gray-400 text-xs">Day Streak</p>
            </div>
          </div>
          
          <button
            onClick={() => {
              logout();
              onAuthSuccess(null);
            }}
            className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-3 rounded-lg"
          >
            Logout
          </button>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      let result;
      if (mode === 'login') {
        result = await login(email, password);
      } else {
        if (!name.trim()) {
          setError('Please enter your name');
          setLoading(false);
          return;
        }
        // ← UPDATED: Pass phone data to register function
        result = await register(email, password, name, phoneData);
      }

      if (result.error) {
        setError(result.error);
      } else if (result.player) {
        onAuthSuccess(result.player);
      }
    } catch (err) {
      setError('Connection failed. Please try again.');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-2xl p-6 w-full max-w-sm">
        {/* Logo/Header */}
        <div className="text-center mb-6">
          <h1 className="text-2xl font-black">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500">TRAK</span>
            <span className="text-white">tag</span>
          </h1>
          <p className="text-gray-400 text-sm mt-1">Quiz Game</p>
        </div>

        {/* Toggle Login/Register */}
        <div className="flex bg-gray-700 rounded-lg p-1 mb-6">
          <button
            onClick={() => setMode('login')}
            className={`flex-1 py-2 rounded-md text-sm font-bold transition ${
              mode === 'login' 
                ? 'bg-purple-600 text-white' 
                : 'text-gray-400 hover:text-white'
            }`}
          >
            Login
          </button>
          <button
            onClick={() => setMode('register')}
            className={`flex-1 py-2 rounded-md text-sm font-bold transition ${
              mode === 'register' 
                ? 'bg-purple-600 text-white' 
                : 'text-gray-400 hover:text-white'
            }`}
          >
            Register
          </button>
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-600/20 border border-red-500 text-red-400 px-4 py-2 rounded-lg mb-4 text-sm">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              {/* Name Field */}
              <div className="mb-4">
                <label className="text-gray-400 text-sm block mb-1">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your display name"
                  className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>

              {/* PHONE INPUT - ADDED HERE */}
<div className="mb-4">
  <PhoneInput
    label="Phone Number (Optional)"
    onChange={(data) => setPhoneData(data)}
    defaultCountry="GB"
    placeholder="Phone number"
  />
</div>
            </>
          )}
          
          <div className="mb-4">
            <label className="text-gray-400 text-sm block mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          
          <div className="mb-6">
            <label className="text-gray-400 text-sm block mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
              className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={`w-full font-bold py-3 rounded-lg transition ${
              loading
                ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                : 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white'
            }`}
          >
            {loading ? 'Please wait...' : mode === 'login' ? 'Login' : 'Create Account'}
          </button>
        </form>

        {/* Skip for now */}
        <button
          onClick={() => onAuthSuccess(null)}
          className="w-full mt-4 text-gray-500 hover:text-gray-400 text-sm"
        >
          Continue as Guest
        </button>
      </div>
    </div>
  );
};

export default AuthScreen;
